'use client';

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent, Ref } from 'react';
import { useTranslations } from 'next-intl';
import styles from './GenerateButton.module.scss';
interface GenerateButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
  ref?: Ref<HTMLButtonElement>;
}
export const GenerateButton = t0 => {
  const $ = _c(15);
  const {
    disabled: t1,
    loading: t2,
    onClick,
    ref
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const t = useTranslations("intro");
  const isInactive = disabled || loading;
  let t3;
  if ($[0] !== isInactive || $[1] !== onClick) {
    t3 = event => {
      if (isInactive) {
        event.preventDefault();
        return;
      }
      onClick();
    };
    $[0] = isInactive;
    $[1] = onClick;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleClick = t3;
  const t4 = isInactive ? styles.ctaDisabled : styles.ctaActive;
  let t5;
  if ($[3] !== t4) {
    t5 = [styles.cta, t4];
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const className = t5.join(" ");
  let t6;
  if ($[5] !== loading || $[6] !== t) {
    t6 = loading ? <span className={styles.spinnerWrap}><span className={styles.spinner} aria-hidden="true" /><span className={styles.spinnerLabel}>{t("aiExperience.generate.loading")}</span></span> : <span className={styles.label}>{t("aiExperience.generate.idle")}</span>;
    $[5] = loading;
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== className || $[9] !== handleClick || $[10] !== isInactive || $[11] !== loading || $[12] !== ref || $[13] !== t6) {
    t7 = <button ref={ref} type="button" disabled={isInactive} aria-busy={loading} onClick={handleClick} className={className}>{t6}</button>;
    $[8] = className;
    $[9] = handleClick;
    $[10] = isInactive;
    $[11] = loading;
    $[12] = ref;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};